import * as types from './constants';

export const loadData = payload => ({ type: types.LOAD_DATA, payload });
export const loadDataSuccess = payload => ({ type: types.LOAD_DATA_SUCCESS, payload });
export const loadDataError = error => ({ type: types.LOAD_DATA_ERROR, error });
